import React, { useEffect, useRef } from 'react';
import { calendlyAuth, getCalendlyToken, getCalendlyApiDetail, unlinkCalendlyApi } from '../../redux/actions/settingActions';
import Unlink from "../../assets/unlink.svg"
import { useDispatch } from 'react-redux';
import * as Icon from "react-bootstrap-icons";
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
const SettingCalendly = (props) => {
    const [code, setCode] = useState("");
    const [calendlyStatus, setCalendlyStatus] = useState("");
    const [calendlyName, setCalendlyName ] = useState("")
    const [calendlyEmail, setCalendlyEmail ] = useState("")
    const dispatch = useDispatch();
    const calendlyUrl = useSelector((state) => state.setting.fetchCalendlyUrl);
    const calendlyUserData = useSelector((state) => state.setting.calendlyData);
    const isMounted = useRef(true);
    let navigate = useNavigate();
    useEffect(() => {
        dispatch(getCalendlyApiDetail(props.authToken, onSuccess));
        setTimeout(() => {
            dispatch(getCalendlyApiDetail(props.authToken, onSuccess));    
        }, 500);
    }, [])
    
    const onSuccess = (value) => {
        setCalendlyStatus(value?.scheduling_url);
        setCalendlyName(value?.name);
        setCalendlyEmail(value?.email);
    }
    
    useEffect(() => {
        // Get the current URL
        const currentURL = window.location.href;
        // Create a URL object to parse the URL
        const url = new URL(currentURL);
        // Get the "code" query parameter value
        const eCode = url.searchParams.get('code');
        if (eCode) {
            // Do something with the extracted "code" value
            console.log('Extracted code:', eCode);
            dispatch(getCalendlyToken(props.authToken, eCode));
            navigate("/Setting/calendly")
            setTimeout(() => {
                window.location.reload();
            }, 500);
            // You can now use the "code" in your React component's state or perform any desired actions.
        } else {
            console.log('No code parameter found in the URL');
        }
        // Cleanup: Set isMounted to false when the component unmounts
    }, []);
    const handleCalendly = () => {
        dispatch(calendlyAuth(props.authToken));
    }
    const handleConnectCalendly = () => {
        if (calendlyUrl) {
            window.location.href = calendlyUrl;
        }
    }
    
    const handleUnlinkCalendly = async () => {
        await dispatch(unlinkCalendlyApi(props.authToken));
        await dispatch(getCalendlyApiDetail(props.authToken, onSuccess));
    }
    return (
        <>
            <div className="px-0">
                <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
                    <div className="text-lg leading-7 font-[500] my-auto">Setup Calendly</div>             
                </div>
                <p className='w-[40%] max-sm:w-full mb-4'>If you happen to have a Calendly account you'd like to have your prospects book a meeting through, you can integrate it into Zoi here.</p>

                <div className='flex justify-start h-[20vh]'>
                    {!calendlyUrl?.length > 0 && <div className='flex justify-center h-[28px] cursor-pointer bg-[var(--brand-primary)] w-[200px] text-white rounded-md text-sm p-1 ' onClick={handleCalendly}><Icon.GearWideConnected className='text-[20px] mr-2'/> Setup Calendly</div>}
                        {calendlyUrl?.length > 0 &&
                            <>
                                {(calendlyStatus === "" || calendlyStatus === null) ? <div className='flex justify-center h-[28px] cursor-pointer bg-[var(--brand-primary)] w-[200px] text-white rounded-md text-sm p-1' onClick={handleConnectCalendly}>
                                    <span className='flex'><Icon.Link45deg className='text-[20px] mr-2'/>Link Calendly</span>
                                </div>:
                                <div className='text-left h-[28px] bg-transparent font-medium w-full text-black rounded-md text-sm p-0'>
                                    <div className='flex justify-center h-[28px] mb-8 cursor-pointer bg-[var(--brand-primary)] w-[200px] text-white rounded-md text-sm p-1' onClick={handleUnlinkCalendly}>
                                        <span className='flex w-full justify-center font-normal'><img src={Unlink} alt="Unlink" className='text-[20px] w-5 h-[18px] mr-2'/> Disconnect Calendly</span>
                                    </div>
                                    <span>Calendly Url : <a className='cursor-pointer text-[var(--brand-primary)]' href={calendlyStatus}>{calendlyStatus }</a></span>
                                </div>}
                            </>
                        }
                </div>
            </div>
        </>
    )
}
export default SettingCalendly;